import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import {
    Button, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text, Image,
    Box,
    Avatar,
    HStack,
    Flex,
    VStack,
    Badge,
    Progress,
    SimpleGrid,
    Alert,
    AlertIcon,
    CloseButton
} from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { keyframes, css } from '@emotion/react';
import { allInGameCharactersConst } from "@/app/const/allInGameCharactersConst";
import TextToSpeechButton from "@/app/layout/global/textToSpeechButton";
import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import { useRouter } from "next/router";
import { buildQuestUrl } from "@/app/helpers/buildUrlHelper";
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import { AllQuestModelConst } from "@/app/const/allQuestModelConst";
import { FaGift } from "react-icons/fa6";
import { FriendsContext } from "@/app/context/friends/friendsContext";
const zoomAndShake = keyframes`
   0% {
   -webkit-transform: scale(0.9);
    transform: scale(0.9);
    transform-origin: center;
  }
  50% {
   -webkit-transform: scale(1.2);
    transform: scale(1.2);
    transform-origin: center;
  }
  100% {
   -webkit-transform: scale(1);
    transform: scale(1);
    transform-origin: center;
  }
`;

type Props = {
    characterId: string
    isOpen: boolean;
    onClose: () => void;
};

export default function CharacterDetailQuestModal({characterId, isOpen,onClose}:Props) {

    const { t } = useTranslation();
    const router = useRouter();
    const {language} = router.query
    const conversationScrollBottom = useRef(null);
    const scrollToBottom = ()=> {
        if (conversationScrollBottom.current !==null) {
            const element = conversationScrollBottom.current as Element;
            element.scrollIntoView()
        }
    }
    const {
        showLoginModal,
        setShowLoginModal,
        user,
        //subscribeNewsletter,
        //setSubscribeNewsletter
    } = useContext(AuthenticationContext)

    const {
        categoryId,
    } = useContext(GlobalDataContext)

    const {
        myArtifacts
    } = useContext(GlobalDataUserContext)

    const {
        canShowFriends,
        friendRequestWithUser,
        showDeleteFriendRequestUserId,
        setShowDeleteFriendRequestUserId,
        isLoadingFriends,
        approveFriend,
        allUserStates,
        friends,
        friendsWithState,
        setShowModalInviteFriends
    } = useContext(FriendsContext)
    
    const character = allInGameCharactersConst.find(character => character.id === characterId)

    const [actualMessageIndex, setActualMessageIndex] = useState(1)
    const [localMessages, setLocalMessages] = useState<any>([])
    const [voiceTalking, setVoiceTalking] = useState(false)
    const [forceStopTalking, setForceStopTalking] = useState(false)    
    const [alreadyGotArtifact, setAlreadyGotArtifact] = useState(false)
    
    useEffect(() => {
        scrollToBottom()
    }, [localMessages])

    useEffect(() => {
        if ( character ){
            if ( !alreadyGotArtifact) {
                setLocalMessages(character.messages.slice(0, actualMessageIndex))
            }else{
                setLocalMessages([character.successMessage])
            }
        }        
    }, [actualMessageIndex,character, language, alreadyGotArtifact])

    useEffect(()=>{
        if ( myArtifacts && character ){
            const artifactId = getArtefactFromCharacter(character.id)
            if ( artifactId && myArtifacts.find(a=>a.id===artifactId)){
                setAlreadyGotArtifact(true)
            }
        }
    }, [myArtifacts, character])

    const goToQuest = () => {
        router.push(buildQuestUrl(language as string, categoryId, character?.questId,"s"), undefined, { shallow: true }).then(()=>{
            onClose();
        })

    }

    const getArtefactFromCharacter = (characterId:string)=>{
        const character = allInGameCharactersConst.find(c=>c.id===characterId)
        if ( !character ) return false
        const quest = AllQuestModelConst.find(q=>q.id===character.questId)
        if ( quest && quest.artifact ){
          return quest.artifact.id
        }
        return false
    }
      
    return (
        <Modal isCentered  isOpen={false} onClose={onClose}>
                <ModalOverlay />
                <ModalContent maxH="80vh" overflow={"hidden"} m={5}  css={css`
                    animation: ${zoomAndShake} 0.7s ease-out;
                `}>
               <ModalCloseButton color="white"/>
                <ModalHeader bg="#009de7!important" color="white" px={4}>
                    <VStack gap="0">
                        <Avatar boxShadow='lg' size="lg" src={(character?.voiceTalkingUrl&&voiceTalking)?character.voiceTalkingUrl:character?.url} icon={undefined}/>
                        <Text>{character?.name}</Text>
                        <Text fontSize="sm" opacity="0.75">{character?.description[language as 'en' | 'fr' | 'de' | 'nl']}</Text>
                    </VStack>
                </ModalHeader>
                <ModalBody p={2} overflow="auto">          
                    <Alert status='info' fontSize="xs" bg="white">
                        <AlertIcon />
                        <Box>
                        {t("quest.goOnPlace")}                        
                        </Box>
                    </Alert>          
                    <Flex direction="column" px={2} py={0}>                        
                        {/*<Box border="1px solid #e7e7e7" px={2} py={2} borderTopRadius={10}>
                            <Text w="full" position="relative" fontSize={"sm"} fontWeight={"bold"} >Termine 10 quêtes <Badge position="absolute" right="1">3/10</Badge></Text>
                            <Flex w="full">
                                <Progress margin="auto" height="18px" value={30} w="full" bg="#ebebeb" borderRadius={15} borderRightRadius={0} borderRight="0" colorScheme="whatsapp"/>
                                <Box bg="#ebebeb" color="#919191" boxShadow='md' borderRadius={"50%"} p="3" border="3px solid white" >
                                    <FaGift fontSize={"1em"}/>
                                </Box>
                            </Flex>
                        </Box>*/}
                        <Box border="1px solid #e7e7e7" borderTop={0} px={2} py={2} borderBottomRadius={10}>
                            <Text w="full" position="relative" fontSize={"sm"} fontWeight={"bold"} >{t("quest.challenge")}</Text>
                            <Flex w="full" direction="column">
                                <SimpleGrid zIndex={2} columns={{base:3,md:4,lg:5}} spacing={5} w="full" p={2} px={0}>
                                    {friendsWithState && friendsWithState.map((friend:any,index:number)=>(
                                        <Box key={index} textAlign="center">
                                            <Avatar size="md" src={friend.user.photoUrl} name={friend.user.name} />
                                            <Text>{friend.user.name}</Text>
                                            <Progress margin="auto" size='xs' value={10} w="full" bg="#ebebeb" borderRadius={15} borderRightRadius={0} borderRight="0" colorScheme="whatsapp"/>
                                        </Box>  
                                    ))}
                                    <Box textAlign="center" onClick={()=>setShowModalInviteFriends(true)}>
                                        <Box 
                                            w={{base:"48px"}}
                                            h={{base:"48px"}}
                                            margin="auto"    
                                            textAlign={"center"}      
                                            p={{base:4}}        
                                            background={"#F16529"}      
                                            borderRadius={"50%"}    
                                            fontSize={"20px"}
                                            fontWeight={"bold"}
                                            lineHeight={"100%"}
                                            color="white"
                                            className="mainButton"
                                        > 
                                            +
                                        </Box>
                                        <Text fontSize={"xs"}>
                                            {t("friends.addFriend")}
                                        </Text>
                                    </Box>
                                </SimpleGrid>
                                <Text fontSize="xs" opacity="0.8">{t("quest.beTheFirst")}</Text>
                            </Flex>
                        </Box>
                    </Flex>
                </ModalBody>
                <ModalFooter px={2} pt={4} pb={2} display="flex">
                    <Button
                        colorScheme="linkedin"
                        onClick={onClose}
                        size="sm"
                    >
                        {t("game.close")}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )

}